<template>
  <div class="content">
    <div class="row mt-0" v-if="editarEscalas == 0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4
            slot="header"
            class="card-title text-left"
            style="padding: 0px; margin: 0px;"
          >
            Escalas Cadastradas
          </h4>
          <div>
            <h5
              class="card-title text-left mt-0 pt-0"
              style="padding: 0px; margin: 0px;"
            >
              <b>Funcionário:</b> {{ funcionarioSelecionado.nome }}
            </h5>
          </div>

          <div style="margin-top: 20px;">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div>
                <el-select
                  class="select-success mb-3 pagination-select"
                  v-model="pagination.perPage"
                  placeholder="Per page"
                >
                  <el-option
                    class="select-success"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div>
              <div
                class="d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <div>
                  <base-button
                    type="info"
                    class="animation-on-hover"
                    @click="voltar()"
                    ><i class="tim-icons icon-minimal-left"></i>
                    Voltar</base-button
                  >
                </div>
              </div>
            </div>

            <el-table :data="queriedData">
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              >
              </el-table-column>
              <el-table-column :min-width="135" align="right" label="Ações">
                <div slot-scope="props">
                  <base-button
                    @click.native="handleEdit(props.$index, props.row)"
                    class="edit btn-link"
                    type="info"
                    size="sm"
                    icon
                  >
                    <i class="tim-icons icon-pencil"></i>
                  </base-button>

                  <base-button
                    @click.native="
                      deletarModeloEscalaFuncionario(props.$index, props.row)
                    "
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="tim-icons icon-simple-remove"></i>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="font-weight-normal">
                Mostrando de {{ from + 1 }} a {{ to }} no total de {{ total }}.
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <EditarEscalas
      :funcionarioSelecionado="funcionarioSelecionado"
      :dadosEscalas="dadosEscalas"
      v-else
      @voltar="voltar"
    />

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card, BasePagination, BaseInput } from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import swal from "sweetalert2";
import Fuse from "fuse.js";
import Modal from "@/components/Modal.vue";
import moment from "moment";
import EditarEscalas from "./EditarEscalas.vue";

export default {
  name: "visualizar-escalas",
  props: {
    funcionarioSelecionado: {
      type: Object,
      default: {},
    },
  },
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseInput,
    Modal,
    EditarEscalas,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      dadosEscalas: [],
      horarioSelecionado: "",
      editarEscalas: 0,
      listEscalasFunc: [],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10],
        total: 0,
      },
      isLoading: false,
      dialogHorarioLimite: false,
      searchQuery: "",
      propsToSearch: ["periodo"],
      tableColumns: [
        {
          prop: "periodo",
          label: "Período",
          minWidth: 200,
        },
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
    };
  },
  mounted() {
    this.listarModeloEscalaFuncionario();
  },
  methods: {
    voltar() {
      this.$emit("voltar", true);
    },
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 2000,
          showConfirmButton: false,
        });
      }
    },

    moment: function(data) {
      return moment(data);
    },

    handleEdit(index, row) {
      this.dadosEscalas = row;
      this.editarEscalas = 1;
    },
    carregarFuse() {
      // Fuse search initialization.
      this.fuseSearch = new Fuse(this.tableData, {
        keys: ["periodo"],
        threshold: 0.3,
      });
    },
    async listarModeloEscalaFuncionario() {
      let th = this;
      this.tableData = [];
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        id_funcionario: this.funcionarioSelecionado.id,
      };
      await this.axios
        .post("/api/escalas/listarModeloDeEscalasFuncionario", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;

          response.data.data.map((dados) => {
            let obj = {
              id_escala_funcionario: dados.id_escala_funcionario,
              periodo:
                this.moment(dados.data[0].data_inicial).format("DD/MM/YYYY") +
                " - " +
                this.moment(dados.data[0].data_final).format("DD/MM/YYYY"),
              data_inicial: dados.data[0].data_inicial,
              data_final: dados.data[0].data_final,
              dados: dados.data,
            };
            th.tableData.push(obj);
          });

          th.tableData.sort(
            (a, b) => b.id_escala_funcionario - a.id_escala_funcionario,
          );

          th.carregarFuse();
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao listar departamentos!",
            "error",
          );
        });
    },

    deletarModeloEscalaFuncionario(index, row) {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        id_escala_funcionario: row.id_escala_funcionario,
      };
      this.axios
        .post("/api/escalas/deletarModeloEscalasFuncionario", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Sucesso",
            "Escala deletada com sucesso!",
            "success",
          );
          th.listarModeloEscalaFuncionario();
          // th.listDepartamentos = response.data.data.dados
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao deletar escalas!",
            "error",
          );
        });
    },
    /* notifyVue(verticalAlign, horizontalAlign) {
        this.$notify({
            component: NotificationHorarioLimite,
            icon: "tim-icons icon-bell-55",
            horizontalAlign: horizontalAlign,
            verticalAlign: verticalAlign,
            type: "warning",
            timeout: 30000
        });
    } */
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>
